import * as React from 'react';

/**
 * @description Plane icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Plane } from '@sravni/design-system-icons'
 *
 * <Plane />
 * ```
 */
const Plane = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "Plane", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "m11.734 5.93 2.76-2.76a1.652 1.652 0 0 1 2.336 2.336l-2.76 2.76 1.493 7.43a.835.835 0 0 1-.227.754l-.55.55a.834.834 0 0 1-1.366-.287l-2.187-5.61-2.838 2.838.152 1.808a.833.833 0 0 1-.241.66l-.905.904-1.768-2.946-2.946-1.768.905-.905a.832.832 0 0 1 .659-.24l1.808.151 2.839-2.838-5.61-2.187A.833.833 0 0 1 3 5.214l.55-.55a.832.832 0 0 1 .753-.227l7.431 1.493Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))));

export { Plane };
//# sourceMappingURL=Plane.js.map
